// FIXME: T235847
// eslint-disable-next-line local-rules/validate-freelancer-imports
import type { Location } from '@freelancer/datastore/collections/project-view-users';

/**
 * The `type` passed to the GMaps API when doing autocompletion.
 * See https://developers.google.com/places/web-service/autocomplete#place_types
 */
export enum AutocompleteLocationType {
  GEOCODING = 'geocode',
  ADDRESS = 'address',
  REGIONS = '(regions)',
  CITIES = '(cities)',
  ALL = 'all',
}

/**
 * The `type` returned by the GMaps API when doing a location search.
 * See https://developers.google.com/places/web-service/supported_types
 */
export enum GoogleMapsLocationTypes {
  ADDRESS = 'address',
  COUNTRY = 'country',
}

export enum LocationError {
  AUTOCOMPLETE_FAILED,
  DETECT_LOCATION_FAILED,
  DETECT_LOCATION_PERMISSION_DENIED,
  DETECT_LOCATION_UNSUPPORTED,
  SELECT_FROM_DROPDOWN,
  AUTOCOMPLETE_ZERO_RESULTS,
  LOCATION_NOT_ALIGNED_WITH_REQUIREMENTS,
}

/**
 * The type of the value of the FormControl passed to LocationInputComponent
 * when the location is parsed by Google Map
 */
export interface LocationInputMapLocation {
  // coordinates are from Geolocation.getCurrentPosition()
  readonly latitude: number;
  readonly longitude: number;
  // coordinates are from google.maps.Geocoder.geocode()
  readonly location: Location;
  readonly type: GoogleMapsLocationTypes;
  // TODO: T250250 - Setting `fullAddress` only needed for testing.
  readonly fullAddress?: string;
}

/**
 * Used as the type for setting an initial address value of the FormControl
 * passed to LocationInputComponent
 */
export interface LocationInputCustomAddress {
  readonly fullAddress: string;
}

/**
 * Used as the type for setting an initial coordinate value of the FormControl
 * passed to LocationInputComponent
 */
export interface LocationInputCustomCoordinate {
  readonly latitude: number;
  readonly longitude: number;
}
